import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import router from "./router";
import store from "./store/store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { WGS84ToGCJ02 } from "./plugin/publicMethod";
//全局CSS
import "./assets/css/main.less";
import axios from "axios";
// 引入echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import "./js/echartsCustom";
import enums from "./js/enums";
Vue.prototype.$enums = enums;

import utils from "./js/index";
Vue.prototype.$utils = utils;

//全局挂载坐标转换
Vue.prototype.WGS84ToGCJ02 = WGS84ToGCJ02;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

import VueCesium from "vue-cesium";
Vue.use(VueCesium, {
  cesiumPath: "/static/Cesium/Cesium.js",
  accessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2YTcyYTZjZS0wZjEyLTRmZjgtOGVlMi1jMGZhM2ZiMTc4NzkiLCJpZCI6OTI2MzEsImlhdCI6MTY1MTg5MTM4OX0.z3uU0iHf4NVtha9G0ujQrvoZbSB925Hf58__auPsWF4"
});


// window.CESIUM_BASE_URL = '/cesium'
//高德地图
import "./plugin/aMap";

Vue.use(ElementUI);
Vue.use(Vuex);
/* eslint-disable no-new */
// axios请求头加入token
axios.interceptors.request.use(
  config => {
    if (config.push === "/") {
    } else {
      if (localStorage.getItem("token")) {
        config.headers.WebToken = localStorage.getItem("token");
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// //响应的token是否过期
// axios.interceptors.response.use(response => {
//     if (response.data.Code == 401 || response.data.Code == 402) {
//       //清除token
//       localStorage.removeItem('token')
//       ElementUI.Message({
//         message: '身份已失效',
//         type: 'warning'
//       });
//       console.log("身份已失效");
//       //返回到登录界面
//       // router.replace({
//         //   path:'/'
//         // })
//         router.push("/")
//         return
//     } else {
//       return response
//     }
//   },
//   error => {
//     return Promise.reject(error)
//   })
//必须登录返回token才能访问其他页面
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断该路由是否需要登录权限
    if (localStorage.getItem("token")) {
      next();
    } else {
      next({
        path: "/"
      });
    }
    //响应的token是否过期
    axios.interceptors.response.use(
      response => { 
        if (response.data.Code == 401 || response.data.Code == 402) {
          //清除token
          localStorage.removeItem("token");
          ElementUI.Message({
            message: "身份已失效",
            type: "warning"
          });
          //返回到登录界面
          router.push("/");
          return;
        } else {
          return response;
        }
      },
      error => {
        return Promise.reject(error);
      }
    );
  } else {
    next();
  }
});
new Vue({
  el: "#app",
  axios,
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js